<script>
	const Q = require('q');
	const util = require('../utilities');
	const _ = require('underscore');
	const model = require('model/model');
	const assignmentService = require('services/assignmentService');
	const moment = require('moment');
	const productService = require('services/productService');
	const classService = require('services/classService');
	const classUtilities = require('utilities/classUtilities');
	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	const {
		fireEvent,
		events: { REASSIGN_ASSIGNMENT, ASSIGN_TRACKED_ASSIGNMENT }
	} = require('utilities/analyticsUtilities');

	const { beginAssignmentAction, endAssignmentAction } = require('utilities/assignmentUtilities');

	const {
		authenticateWithGoogleClassroom,
		isKnownGoogleClass,
		closeGCAIframe,
		isInvalidatingGoogleError
	} = require('utilities/googleClassroomUtilities');

	const studentGroupUtilities = require('utilities/studentGroupUtilities');

	// we need to be able to blank all data quickly when the product-id changes
	// (such as in my-list.vue)
	var BLANK_DATA = {
		assignArticle: true, // a
		assignAudio: false, // au
		assignEBook: false, // ebook
		assignBookOfKnowledge: false, // bok
		assignVocabActivities: true,
		questionSets: [], // qs[]
		classCode: '',
		productId: '',
		studentChoice: '',
		studentSelections: [],
		stepReads: [],
		ell: false,
		hasVocabularyActivities: false,
		productType: null,
		publishToGoogleClassroom: true,
		showResults: true,
		video: false,
		selectedGroup: '',
		challengeArticles: false,
		supportArticles: false,
		wordDetective: false,
		meaningMapper: false,
		decodables: false
	};

	module.exports = {
		props: {
			// This will be used to pull the product. It's versioned
			'product-id': {
				required: false
			},

			// if present, show the article title beneath the "Assign" header in the modal
			'show-article-title': {
				required: false,
				type: Boolean
			},

			'full-or-express': {
				required: false
			}
		},
		components: {
			'assignment-modal-form-left': require('./assignment-modal/form-left.vue').default,
			'assignment-modal-form-right': require('./assignment-modal/form-right.vue').default,
			'form-submitter': require('components/form-submitter.vue').default,
			message: require('components/message.vue').default
		},

		modelData: ['localGCAccessToken', 'studentGroups', 'articleEntryPoint', 'gcClassList', 'gcAddon'],

		data: function () {
			let today = moment().startOf('day').valueOf();
			let deadline = moment(today).add(13, 'days').valueOf();

			return {
				verifyDupeOK: false,
				assignmentExists: false,
				assignmentStateReady: false,
				assignedAction: 'Created',
				product: {},
				classesByCode: {},
				loadingClasses: true,
				classCount: 0,
				classesLoaded: false,
				modalIsOpen: false,
				// make a deep copy of BLANK_DATA (so we don't mess with the original)
				newAssignmentForm: $.extend(true, {}, BLANK_DATA),
				optionsError: '',
				studentSelectionError: '',
				showConfirmation: false,

				submitting: false, // is a submit in progress

				// These 2 variables are used when showing confirmation of the assignment
				partsAssigned: '',
				assignedToConfirmation: '',
				studentChoiceConfirmation: '',
				assignmentDateConfirmation: '',
				assignmentELLConfirmation: '',
				assignmentDeadlineConfirmation: '',
				assignmentGoogleClassroomConfirmation: '',
				classNameConfirmation: '',

				// this variable will be 'c' for whole class or 's' for individual students, used to
				// show/hide the students selection, load the roster and change the modal layout from
				// 1-column & normal-width to 2-column & wide-width
				assignTo: 'c',

				// This variable tracks whether the roster is currently waiting to load or not,
				// it's used so that we can disable the submit button while a class roster loads
				rosterReady: false,

				studentSelections: {},

				studentChoices: [
					{
						text: 'Students read the same articles',
						value: 'o'
					},
					{
						text: 'Students choose between two articles',
						value: 't'
					},
					{
						text: 'Students can choose any article in the set',
						value: ''
					}
				],

				startDate: today,
				deadline: deadline,

				loadingProduct: true,

				previousAID: null,

				loadingGroups: false,
				assignment: null
			};
		},

		computed: {
			currentClass: function () {
				let classesByCode = this.classesByCode;
				let classCode = this.newAssignmentForm.classCode;
				let clazz = {};

				if (classCode) {
					clazz = classesByCode[classCode];
				}

				return clazz;
			},
			currentClassHasEll: function () {
				let students = this.newAssignmentForm.studentSelections;
				if (this.rosterReady && students && students.length) {
					let enable = students.some(s => s.ell && s.ell !== '');
					return enable;
				}
				return false;
			},
			gcTokenMismatch() {
				const gcid = this.currentClass && this.currentClass.gcid;

				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			},
			needsGoogleAuth() {
				const gcid = this.currentClass && this.currentClass.gcid;
				const gcPublish = this.newAssignmentForm.publishToGoogleClassroom;

				return gcid && (gcPublish || this.gcAddon) && (!this.localGCAccessToken || this.gcTokenMismatch);
			},
			groups() {
				let studentGroups = this.studentGroups || [];
				let clazz = this.currentClass;
				let students = (clazz && clazz.roster) || [];
				let studentsById = students.reduce((acc, s) => {
					acc[s] = true;
					return acc;
				}, {});

				return studentGroups.reduce((acc, g) => {
					let suids = Object.keys(g.suids || {});
					let count = 0;
					suids.forEach(suid => {
						if (studentsById[suid]) {
							count++;
						}
					});
					if (count) {
						acc.push({
							text: g.n,
							disabled: count < 1,
							value: g.id
						});
					}
					return acc;
				}, []);
			},
			groupsById() {
				return this.studentGroups.reduce((acc, g) => {
					acc[g.id] = g;
					return acc;
				}, {});
			},
			assignmentTarget() {
				const cc = this.newAssignmentForm.classCode;
				const classCode = cc ? `classCode:${cc}/` : '';
				const isFutureDate = moment(this.assignmentDateConfirmation).startOf('day').valueOf() > moment().startOf('day').valueOf();
				const assignmentListTab = `assignmentListTab:${isFutureDate ? 'f' : 'a'}`;

				return `/assignments#!${classCode}${assignmentListTab}`;
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		},
		mounted() {
			var self = this;

			this.$subscribe('modal-closed', modalId => {
				if (modalId !== 'modal-assign') {
					return;
				}
				if (this.showConfirmation) {
					if (this.gcAddon) {
						closeGCAIframe();
					}
				}
				this.clearConfirmationForm();
				this.modalIsOpen = false;
			});

			this.$subscribe('modal-opened', (modalId, options) => {
				if (modalId !== 'modal-assign') {
					return;
				}

				if (options.assignment) {
					this.assignment = options.assignment;
				}

				if (options.reloadClasses || !this.classesLoaded) {
					this.reloadClasses();
				}

				this.checkIfAssignmentExists();
				this.getProductInfo();

				this.modalIsOpen = true;
				this.previousAID = null;
			});

			self.$watch('loadingClasses', _.bind(self.openClassCreationIfNoClasses, self));
			self.$watch('modalIsOpen', _.bind(self.openClassCreationIfNoClasses, self));
			self.$watch('product', _.bind(self.openClassCreationIfNoClasses, self));

			self.$watch('newAssignmentForm.classCode', _.bind(self.reloadRoster, self));
			self.$watch('newAssignmentForm.classCode', self.checkIfAssignmentExists.bind(self));
			self.$watch('newAssignmentForm.classCode', self.updateAssignmentSettings.bind(self));
			self.$watch('newAssignmentForm.classCode', self.fetchGroups.bind(self));
			self.$watch('assignTo', _.bind(self.reloadRoster, self));
			self.$watch('groups', _.bind(self.onGroupsChange, self));

			pubsub.subscribe('submit-succeeded', evData => {
				if (evData.formName !== 'newAssignmentForm') {
					return true;
				}
				let clazz = self.currentClass;

				self.submitting = false;
				self.showConfirmation = true;
				var parts = [];
				if (self.newAssignmentForm.assignArticle) {
					parts.push('Article');
				}

				if (self.newAssignmentForm.hasVocabularyActivities && self.newAssignmentForm.assignVocabActivities) {
					parts.push('Vocabulary Activity');
				}

				if (self.newAssignmentForm.assignBookOfKnowledge) {
					parts.push('Book of Knowledge Activity');
				}

				if (self.newAssignmentForm.assignAudio) {
					parts.push('Audio');
				}

				if (self.newAssignmentForm.challengeArticles) {
					parts.push('Challenge Articles');
				}

				if (self.newAssignmentForm.supportArticles) {
					parts.push('Boost Articles');
				}

				if (self.newAssignmentForm.wordDetective) {
					parts.push('Word Detective');
				}

				if (self.newAssignmentForm.meaningMapper) {
					parts.push('Meaning Mapper');
				}

				if (self.newAssignmentForm.assignEBook) {
					parts.push('eBook');
				}

				if (self.newAssignmentForm.video) {
					parts.push('Video');
				}

				_.each(self.newAssignmentForm.stepReads, function (sr) {
					if (sr.selected) {
						parts.push('SR' + sr.order);
					}
				});

				_.each(self.newAssignmentForm.questionSets, function (qset) {
					if (qset.selected) {
						parts.push(qset.title);
					}
				});

				if (self.newAssignmentForm.decodables) {
					parts.push('Decodables');
				}

				self.partsAssigned = parts.join(', ');
				var assignedTo = [];
				if (self.assignTo === 'c') {
					assignedTo.push('Whole Class');
				} else if (self.assignTo === 'g') {
					let groupName = '';
					this.studentGroups.some(g => {
						if (g.id === self.newAssignmentForm.selectedGroup) {
							groupName = g.n;
							return true;
						}
						return false;
					});
					assignedTo.push(groupName);
				} else {
					_.each(self.newAssignmentForm.studentSelections, function (s) {
						if (s.selected) {
							assignedTo.push(s.text);
						}
					});
				}

				let studentChoiceVal = self.newAssignmentForm.studentChoice;
				if (self.product.productType === 'AAD') {
					self.studentChoices.every(choiceItem => {
						if (choiceItem.value === studentChoiceVal) {
							self.studentChoiceConfirmation = choiceItem.text;
							return false;
						}
						return true;
					});
				}

				self.assignedToConfirmation = assignedTo.join(', ');
				self.assignmentDateConfirmation = moment(self.startDate || new Date().setHours(0, 0, 0, 0)).format('M/D/YYYY');
				self.assignmentDeadlineConfirmation = moment(self.deadline || new Date().setHours(0, 0, 0, 0)).format('M/D/YYYY');

				if (self.newAssignmentForm.classCode) {
					self.classNameConfirmation = clazz && clazz.name ? clazz.name : '';
				}

				if (self.newAssignmentForm.ell) {
					self.assignmentELLConfirmation = 'Turned On';
				}

				if (clazz?.gcid && self.newAssignmentForm.publishToGoogleClassroom) {
					self.assignmentGoogleClassroomConfirmation = 'Published';
				}

				return true;
			});

			pubsub.subscribe('before-submit', function (evData) {
				if (evData.formName === 'newAssignmentForm') {
					self.submitting = true;
				}

				return true;
			});

			pubsub.subscribe('submit-failed', function (evData) {
				if (evData.formName !== 'newAssignmentForm') {
					return true;
				}
				let err = evData && evData.err ? evData.err : null;

				self.submitting = false;

				if (isInvalidatingGoogleError(err)) {
					model.set('localGCAccessToken', '');
				}

				if (err?.code === 1115) {
					self.fetchGroups(self.newAssignmentForm.classCode);
					self.verifyDupeOK = false;
				}

				// if class creation succeeded, but assignment failed, then switch the class
				// selection to the new class code
				if (evData.data && evData.data.classCode) {
					self.newAssignmentForm.classCode = evData.data.classCode;
				}

				return true;
			});

			self.$watch('assignment', function (value) {
				if (value) {
					self.startDate = value.startDate * 1000;
					self.deadline = value.deadline ? value.deadline * 1000 : null;
				} else {
					self.startDate = null;
					self.deadline = null;
				}
			});

			// in some contexts (e.g. /my-list) the product hasn't been loaded yet, so we
			// load it now
			self.$watch('productId', self.getProductInfo, {
				immediate: true
			});
		},
		methods: {
			getProductInfo: function () {
				var self = this;

				self.resetForm();

				if (self.productId) {
					self.loadingProduct = true;

					productService
						.get(self.productId)
						.then(function (product) {
							if (product) {
								// We have the versioned response
								if (product.id === self.productId) {
									self.loadingProduct = false;
								}

								self.product = product;
								self.newAssignmentForm.productType = product.productType;
								if (product.productType === 'AAD') {
									self.newAssignmentForm.assignBookOfKnowledge = true;
								}

								self.initQuestionSetChoices();

								if (product.sr) {
									self.initStepReadChoices();
								}

								self.newAssignmentForm.hasVocabularyActivities = false;

								if (product.vocab && product.vocab.activity) {
									self.newAssignmentForm.hasVocabularyActivities = true;
								}

								if (self.assignment) {
									self.newAssignmentForm.assignArticle = self.assignment.options.assignArticle;
									self.newAssignmentForm.assignAudio = self.assignment.options.assignAudio;
									self.newAssignmentForm.challengeArticles = self.assignment.options.challengeArticles;
									self.newAssignmentForm.supportArticles = self.assignment.options.supportArticles;
									self.newAssignmentForm.wordDetective = self.assignment.options.wordDetective;
									self.newAssignmentForm.meaningMapper = self.assignment.options.meaningMapper;
									self.newAssignmentForm.assignEBook = self.assignment.options.assignEBook;
									self.newAssignmentForm.assignBookOfKnowledge = self.assignment.options.assignBookOfKnowledge;
									self.newAssignmentForm.classCode = self.assignment.classCode;
									self.newAssignmentForm.productId = self.assignment.productId;
									self.newAssignmentForm.ell = self.assignment.options.ell;
									self.newAssignmentForm.studentChoice = self.assignment.studentChoice || '';
									self.newAssignmentForm.publishToGoogleClassroom = !!self.assignment.gcid;
									self.newAssignmentForm.showResults = self.assignment.showResults;
									self.newAssignmentForm.video = self.assignment.options.video;

									self.newAssignmentForm.questionSets.forEach(function (qs) {
										qs.selected = false;
									});

									const expressQsLookup = (self.assignment.options.expressQuestionSets || []).reduce((lookup, qsid) => {
										lookup[qsid] = true;
										return lookup;
									}, {});

									if (self.assignment.options.questionSets) {
										self.assignment.options.questionSets.forEach(function (qs) {
											for (var i = 0; i < self.newAssignmentForm.questionSets.length; i++) {
												if (self.newAssignmentForm.questionSets[i].qsid === qs) {
													self.newAssignmentForm.questionSets[i].selected = true;
													if (expressQsLookup[qs]) {
														self.newAssignmentForm.questionSets[i].fullOrExpress = 'x';
													}
													break;
												}
											}
										});
									}

									self.studentSelections = {};

									if (self.assignment.group && self.studentGroups && self.groupsById[self.assignment.group]) {
										self.newAssignmentForm.selectedGroup = self.assignment.group;
										self.assignTo = 'g';
									}
									if (
										!self.newAssignmentForm.selectedGroup &&
										self.assignment.studentUids &&
										self.assignment.studentUids.length &&
										(!self.assignment.type || self.assignment.type === 's')
									) {
										self.assignment.studentUids.forEach(function (uid) {
											self.studentSelections[uid] = true;
										});

										self.assignTo = 's';
									}

									if (self.assignment.options.assignStepReads && self.newAssignmentForm.stepReads) {
										var srMap = {};

										self.assignment.options.assignStepReads.forEach(function (srId) {
											srMap[srId] = true;
										});

										self.newAssignmentForm.stepReads.forEach(function (sr) {
											if (srMap[sr.uuid]) {
												sr.selected = true;
											}
										});
									}

									self.newAssignmentForm.assignVocabActivities = self.assignment.options.vocabularyActivities.length > 0;
								}
							}
						})
						.then(() => {
							if (self.newAssignmentForm.classCode) {
								self.reloadRoster();
							}
							return true;
						});
				}
			},
			checkIfAssignmentExists: function () {
				if (this.newAssignmentForm.classCode === 'new') {
					this.assignmentExists = false;
					this.assignmentStateReady = true;

					return;
				}

				this.assignmentStateReady = false;

				if (!this.newAssignmentForm.classCode || !this.productId || this.assignment) {
					this.assignmentExists = false;
					this.assignmentStateReady = true;
					return;
				}

				var productId = this.productId;
				if (util.productIdHasVersion(productId)) {
					productId = util.parseProductUUIDAndVersion(productId).uuid;
				}

				assignmentService
					.assignmentExists({
						productId: productId,
						classCode: this.newAssignmentForm.classCode
					})
					.then(
						function (result) {
							this.assignmentExists = !!result;
							this.assignmentStateReady = true;
						}.bind(this)
					);
			},
			createAssignmentAndOptionalClass: function (params, cb) {
				this.assignedAction = 'Created';

				params.date = this.startDate || new Date().setHours(0, 0, 0, 0);

				var self = this;

				if (this.assignTo === 'c') {
					delete params.studentSelections;
					delete params.selectedGroup;
				} else if (this.assignTo === 'g') {
					delete params.studentSelections;
				} else {
					delete params.selectedGroup;
				}

				const product = this.product;
				if (params.hasVocabularyActivities && params.assignVocabActivities) {
					const activityTypes = {};
					if (product.vocab && product.vocab.activity) {
						Object.keys(product.vocab.activity).forEach(k => {
							activityTypes[k] = 1;
						});
					}
					params.vocabularyActivities = Object.keys(activityTypes);
				}
				delete params.assignVocabActivities;
				delete params.hasVocabularyActivities;

				if (params.decodables && product.dteGroups) {
					// update if flexibility given to assignable dte group
					params.decodables = product.dteGroups.map(group => group.id);
				} else {
					delete params.decodables;
				}

				if (this.assignment) {
					// Update

					if ((this.assignTo === 'c' || this.assignTo === 's') && this.assignment.group) {
						params.selectedGroup = '';
					}

					let deadline = this.deadline;
					// If deadline was updated using the calendar picker
					if (deadline !== this.assignment.deadline * 1000) {
						// submit deadline as 11:59PM on the day selected.
						deadline = moment(deadline).add(1, 'days').subtract(1, 'minutes').valueOf();
					}
					params.deadline = deadline;

					if (this.assignment.gcid) {
						params.token = this.localGCAccessToken;
					}

					if (
						(!this.assignment.studentChoice || this.assignment.classCode !== this.newAssignmentForm.classCode) &&
						!this.newAssignmentForm.studentChoice
					) {
						delete params.studentChoice;
					}

					beginAssignmentAction();
					assignmentService
						.updateFutureAssignment(
							_.extend(
								{
									aid: this.assignment.assignmentId,
									currentClassCode: this.assignment.classCode
								},
								params
							)
						)
						.then(function (result) {
							endAssignmentAction();
							self.assignedAction = 'Updated';
							self.verifyDupeOK = false;
							cb(null, result || {});
						})
						.fail(cb)
						.fail(function (err) {
							self.verifyDupeOK = false;
							endAssignmentAction();

							throw err;
						});
				} else {
					// Insert
					// submit deadline as 11:59PM on the day selected.
					var deadline = moment(this.deadline).add(1, 'days').subtract(1, 'minutes').valueOf();
					params.deadline = deadline;
					params.showResults = this.newAssignmentForm.showResults;
					const gcAddon = this.gcAddon;

					if (gcAddon || (this.newAssignmentForm.publishToGoogleClassroom && this.currentClass.gcid)) {
						params.gc = true;
						params.token = this.localGCAccessToken;
					}

					if (gcAddon) {
						params.gcAddon = _.pick(gcAddon, 'addOnToken', 'itemId');
					}

					if (!this.newAssignmentForm.studentChoice) {
						delete params.studentChoice;
					}

					beginAssignmentAction();

					// WEB-1371 Litmus Experiment
					// WEB-1425
					// WEB-1428
					// Currently all experiments run for grade 3, 4, 5
					//   but only 1428 / 29e7182a-24ba-495b-a0c8-d2d28da03e4d includes 6th grade
					if (this.product.hasExperiment()) {
						let gradeForClass = this.classesByCode[params.classCode].grade;
						let uuid = this.product.uuid;

						if (uuid === '29e7182a-24ba-495b-a0c8-d2d28da03e4d' && gradeForClass === '22') {
							params.productId = this.product.getVersionForExperiment();
						} else if (gradeForClass === '19' || gradeForClass === '20' || gradeForClass === '21') {
							params.productId = this.product.getVersionForExperiment();
						}
					}

					const origin = this.articleEntryPoint;

					if (origin) {
						fireEvent(ASSIGN_TRACKED_ASSIGNMENT, {
							pid: this.productId,
							cc: params.classCode,
							origin
						});
					}

					assignmentService
						.createAssignment(params)
						.then(function (result) {
							self.verifyDupeOK = false;
							self.assignmentExists = true;
							endAssignmentAction();
							self.previousAID = result.aid;
							cb(null, result);
							return result.aid;
						})
						.fail(cb)
						.fail(function (err) {
							self.verifyDupeOK = false;
							endAssignmentAction();

							throw err;
						});
				}
			},

			openClassCreationIfNoClasses: function () {
				if (this.modalIsOpen && !this.loadingClasses && this.classCount === 0 && this.product !== null) {
					util.openModal('#modal-create-class', {
						createAssignmentMessage: true,
						returnToProduct: this.product.uuid
					});
				}
			},
			reloadClasses() {
				this.loadingClasses = true;
				let prms = classUtilities.loadActiveClasses();
				const gcAddon = this.gcAddon;

				prms.then(classes => {
					var cc = '';
					if (classes && classes.length) {
						this.classesLoaded = true;
					}
					classes = util.sortObjects(classes, 'name');

					const { classesByCode, classChoices } = classes.reduce(
						(acc, c, index) => {
							const { classCode, name, gcid } = c;

							if (gcAddon) {
								if (gcid === gcAddon.courseId) {
									cc = classCode;
									acc.classesByCode[classCode] = c;
									acc.classChoices.push({
										text: name,
										value: classCode
									});
								}

								return acc;
							}

							if (index === 0) {
								cc = c.classCode;
							}

							acc.classesByCode[classCode] = c;
							acc.classChoices.push({
								text: name,
								value: classCode
							});
							return acc;
						},
						{ classesByCode: {}, classChoices: [] }
					);

					this.classCount = classes.length;

					//classChoices.push({text:'Create a Class', value:'new'});
					this.classes = classChoices;
					this.classesByCode = classesByCode;

					if (!cc) {
						cc = 'new';
					}

					if (this.assignment) {
						this.newAssignmentForm.classCode = this.assignment.classCode;
					} else {
						this.newAssignmentForm.classCode = cc;
					}

					this.updateAssignmentSettings(cc);

					this.loadingClasses = false;
				});
			},
			reloadRoster: function () {
				var self = this;

				if (self.assignTo === 'c' || self.newAssignmentForm.classCode === 'new') {
					self.assignTo = 'c';
					self.newAssignmentForm.studentSelections = [];
					self.studentSelectionError = '';
				}

				if (self.newAssignmentForm.classCode && self.newAssignmentForm.classCode !== 'new') {
					// Request roster on class change to check ELL
					self.rosterReady = false;

					classService
						.getClassRoster({
							classCode: self.newAssignmentForm.classCode
						})
						.then(function (roster) {
							var labels = util.unambiguousStudentLabels(roster.students);
							var choices = [];
							_.each(roster.students, function (student) {
								student.text = labels[student.uid] || student.firstName || '[Unknown Name]';
								student.selected = student.uid in self.studentSelections;
								choices.push(student);
							});

							self.newAssignmentForm.studentSelections = util.sortObjects(choices, 'firstName');
							self.rosterReady = true;
						});
				}
			},
			/**
			 * Reset the form to a clean, initial state (assign to whole class, nothing selected)
			 */
			resetForm: function () {
				pubsub.publish('form-reset');
				this.optionsError = '';
				this.studentSelectionError = '';
				this.assignTo = 'c';
				this.studentSelections = {};

				// make a deep copy of BLANK_DATA (so we don't mess with the original)
				var blank = $.extend(true, {}, BLANK_DATA);

				blank.productId = this.productId;
				delete blank.classCode;

				// copy each property from blank to $data.newAssignmentForm
				$.extend(this.newAssignmentForm, blank);
				this.onGroupsChange();
			},
			/**
			 * Setup the question set choices based on the product (product may already be
			 * loaded, or we may have to make a server call, so we need this method)
			 */
			initQuestionSetChoices: function () {
				const questionSetsOrdered = this.product.questionSetsOrdered || [];
				let sets = [];

				questionSetsOrdered.forEach((qs, idx) => {
					const { qsid, abridged_question_ids: abridged, title, isSkill } = qs;
					const fullOrExpress = abridged && abridged.length > 0 ? (this.fullOrExpress && this.fullOrExpress[qsid]) || 'f' : null;
					if (!qs.vocabularyWord) {
						sets.push({
							title,
							qsid,
							fullOrExpress,
							selected: !isSkill
						});
					}
				});

				if (sets.length === 1) {
					sets[0].selected = true;
				}

				this.newAssignmentForm.questionSets = sets;
			},
			initStepReadChoices: function () {
				this.newAssignmentForm.stepReads = _.values(this.product.articles).sort(function (a, b) {
					return a.order - b.order;
				});
			},
			selectAllStudents: function (selected) {
				_.each(this.newAssignmentForm.studentSelections, function (s) {
					s.selected = selected;
				});
			},
			ensureSelectionsOK: function () {
				var selectionCount = 0;
				this.customError = '';

				if (!this.product) {
					return false;
				}

				_.each(this.newAssignmentForm.questionSets, function (s) {
					if (s.selected) {
						selectionCount++;
					}
				});

				if (this.newAssignmentForm.assignArticle) {
					selectionCount++;
				}

				if (this.newAssignmentForm.assignAudio) {
					selectionCount++;
				}

				if (this.newAssignmentForm.assignEBook) {
					selectionCount++;
				}

				if (this.newAssignmentForm.assignBookOfKnowledge) {
					selectionCount++;
				}

				if (this.assignTo === 's') {
					var studentsSelected = _.filter(this.newAssignmentForm.studentSelections, function (s) {
						return s.selected;
					}).length;

					if (studentsSelected === 0) {
						this.studentSelectionError = 'Please select at least one student.';
						this.verifyDupeOK = false;
						return false;
					}
				}

				if (selectionCount === 0) {
					this.optionsError = 'You must select at least one of "Article" or a question set.';
					this.verifyDupeOK = false;
					return false;
				} else {
					return true;
				}
			},
			clearConfirmationForm: function () {
				this.showConfirmation = false;
				this.verifyDupeOK = false;
				this.partsAssigned = '';
				this.assignedToConfirmation = '';
				this.studentChoiceConfirmation = '';
				this.assignmentELLConfirmation = '';
				this.assignmentDateConfirmation = '';
				this.assignmentDeadlineConfirmation = '';
				this.assignmentGoogleClassroomConfirmation = '';
				this.classNameConfirmation = '';
				this.assignment = null;
			},
			assignAgain: function () {
				const pid = this.productId;
				const aid = this.previousAID;
				const origin = this.articleEntryPoint;

				this.showConfirmation = false;
				this.clearConfirmationForm();
				fireEvent(REASSIGN_ASSIGNMENT, { pid, aid, origin });
			},
			updateAssignmentSettings: function (cc) {
				let clazz = this.classesByCode[cc];
				if (clazz && clazz.settings) {
					if (typeof clazz.settings.publishToGoogleClassroom !== 'undefined') {
						this.newAssignmentForm.publishToGoogleClassroom = clazz.settings.publishToGoogleClassroom;
					}
					if (typeof clazz.settings.showResults !== 'undefined') {
						this.newAssignmentForm.showResults = clazz.settings.showResults;
					}
				}
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			},
			fetchGroups() {
				let cc = this.newAssignmentForm.classCode;
				let prms = Q();
				this.loadingGroups = true;
				if (cc && cc !== 'new') {
					prms = studentGroupUtilities.fetchGroups(cc).finally(() => (this.loadingGroups = false));
				}
				return prms;
			},
			onGroupsChange() {
				const groups = this.groups;
				if (groups && groups.length) {
					const hasSelectedGroup = groups.some(group => group.value === this.newAssignmentForm.selectedGroup);

					if (!hasSelectedGroup) {
						this.newAssignmentForm.selectedGroup = groups[0].value;
					}
				} else if (this.assignTo === 'g') {
					this.assignTo = 'c';
				}
			}
		}
	};
</script>
<style lang="scss">
	#modal-assign {
		.validation-error {
			color: red;
		}

		form .input-select {
			margin-bottom: 0rem;
		}

		.modal-content-main {
			.go-to-assignments-button,
			.close-button {
				text-align: center;
			}
		}

		.google-auth-button {
			max-width: 20rem;
			box-sizing: content-box;
			text-align: center;
		}
	}
</style>
<template>
	<modal
		id="modal-assign"
		:wide="assignTo === 's' && !showConfirmation && !verifyDupeOK"
		:loading="loadingClasses || !rosterReady || loadingProduct || loadingGroups"
		:centered="verifyDupeOK">
		<template slot="header-container">
			<template v-if="showConfirmation">
				<h2>Assignment {{ assignedAction }}</h2>
				<h3>{{ product.title }}</h3>
				<div
					v-if="classNameConfirmation"
					class="text-muted">
					{{ classNameConfirmation }}
				</div>
			</template>
			<template v-else>
				<h2 v-if="!submitting">Assign</h2>
				<h2 v-if="submitting">
					Creating Assignment
					<img
						:src="loaderImageSrc"
						alt="Loading" />
				</h2>
				<h3 v-if="showArticleTitle && product">{{ product.title }}</h3>
				<div
					v-if="product.productType === 'P'"
					class="font-small text-muted">
					{{ product.hasVideo ? 'Paired Video' : product.subType === 8001 ? 'Spanish-English Paired Text' : 'Paired Text' }}
				</div>
				<div
					v-if="product.productType === 'AAD'"
					class="font-small text-muted">
					Article-A-Day Set
				</div>
			</template>
		</template>
		<template slot="content">
			<template v-if="showConfirmation">
				<p><strong>Assigned:</strong> {{ partsAssigned }}</p>
				<p v-if="product.productType === 'AAD'"><strong>Student Choice:</strong> {{ studentChoiceConfirmation }}</p>
				<p><strong>Assigned to:</strong> {{ assignedToConfirmation }}</p>
				<p v-if="newAssignmentForm.ell"><strong>ELL and Extra Support features:</strong> {{ assignmentELLConfirmation }}</p>
				<p v-if="currentClass.gcid && newAssignmentForm.publishToGoogleClassroom">
					<strong>Google Classroom:</strong> {{ assignmentGoogleClassroomConfirmation }}
				</p>
				<p><strong>Assignment Start Date:</strong> {{ assignmentDateConfirmation }}</p>
				<p v-if="deadline">
					<strong>{{ product.productType === 'AAD' ? 'End Date' : 'Due Date' }}:</strong> {{ assignmentDeadlineConfirmation }}
				</p>
				<div class="close-button margin-top-bottom-medium">
					<button
						data-modal-close
						class="button">
						Ok
					</button>
				</div>
				<div
					v-if="assignedAction === 'Created' && !gcAddon"
					class="go-to-assignments-button margin-top-bottom-medium">
					<button
						class="button -small -outline"
						@click="assignAgain">
						Assign Again
					</button>
					<a
						:href="assignmentTarget"
						class="button -small -outline">
						Go to Assignments
					</a>
				</div>
			</template>
			<template v-if="!showConfirmation">
				<form-submitter
					form-name="newAssignmentForm"
					:form-data.sync="newAssignmentForm"
					:submit-to="createAssignmentAndOptionalClass"
					:custom-validator="ensureSelectionsOK"
					method="post"
					no-close-modal
					action="./"
					class="form"
					novalidate>
					<div v-if="verifyDupeOK">
						<p>You have already assigned this Article to this Class.</p>
						<p>Are you sure you want to assign this article again?</p>
					</div>
					<div
						v-else
						:class="{ 'modal-row': assignTo === 's' }">
						<div
							:class="{
								'modal-column': assignTo === 's',
								'modal-column-left': assignTo === 's'
							}">
							<div
								class="form-row"
								v-if="optionsError">
								<div class="validation-error">
									{{ optionsError }}
								</div>
							</div>
							<assignment-modal-form-left
								:new-assignment-form.sync="newAssignmentForm"
								:assign-to.sync="assignTo"
								:product="product"
								:classes="classes"
								:loading-classes="loadingClasses"
								:classes-by-code="classesByCode"
								:student-choices="studentChoices"
								:start-date.sync="startDate"
								:deadline.sync="deadline"
								:current-class-has-ell="currentClassHasEll"
								:assignment="assignment"
								:groups="groups"
								:gc-addon="gcAddon">
							</assignment-modal-form-left>
						</div>
						<div
							class="modal-column modal-column-right"
							v-if="assignTo === 's' && rosterReady">
							<assignment-modal-form-right
								:new-assignment-form.sync="newAssignmentForm"
								:select-all-students="selectAllStudents"
								:student-selection-error="studentSelectionError">
							</assignment-modal-form-right>
						</div>
					</div>
					<br v-if="(assignTo === 'c' || assignTo === 'g') && !verifyDupeOK" />
					<message
						v-if="gcTokenMismatch"
						class="margin-top-xs"
						type="error">
						Please authenticate the Google account used to manage this Classroom
					</message>
					<button
						type="button"
						class="google-auth-button button -large -wide -centered margin-bottom-small"
						v-if="needsGoogleAuth"
						@click="authenticateWithGoogle">
						Authenticate With Google
					</button>
					<auto-form-row
						v-if="(verifyDupeOK || !assignmentExists) && !needsGoogleAuth"
						row-class="-wide -centered"
						:all-valid="newAssignmentForm.allValid && rosterReady && assignmentStateReady"
						type="submit">
						Assign
					</auto-form-row>
					<div
						class="form-row"
						v-else>
						<div class="form-row-input">
							<button
								class="button -large -wide -centered -verify-dupe-ok"
								:class="{ '-disabled': !(newAssignmentForm.allValid && rosterReady && assignmentStateReady && !needsGoogleAuth) }"
								:disabled="!(newAssignmentForm.allValid && rosterReady && assignmentStateReady && !needsGoogleAuth)"
								v-on:click.prevent="verifyDupeOK = true">
								Assign
							</button>
						</div>
					</div>
					<div
						class="form-row"
						v-if="verifyDupeOK">
						<div class="form-row-input">
							<button
								class="button -large -outline -centered"
								:class="{ '-disabled': !(newAssignmentForm.allValid && rosterReady && assignmentStateReady) }"
								:disabled="!(newAssignmentForm.allValid && rosterReady && assignmentStateReady)"
								v-on:click.prevent="verifyDupeOK = false">
								Go Back
							</button>
						</div>
					</div>
				</form-submitter>
			</template>
			<!-- end v-if="!showConfirmation && !verifyDupeOK" -->
		</template>
		<!-- end slot="content" -->
	</modal>
</template>
